import { isUploadError } from 'src/lib/errors';

export function parseError(error) {
  if (!error) {
    return { title: '' };
  }

  if (error.networkError) {
    if (error.networkError.result?.error) {
      return {
        title: 'Network error',
        description: error.networkError.result.error,
      };
    }

    return {
      title: 'Network error',
      description: error.networkError.message,
    };
  }
  if (error.graphQLErrors && error.graphQLErrors.length > 0) {
    return {
      description: error.graphQLErrors.map((gqlError) => gqlError.message).join('\n'),
    };
  }

  if (isUploadError(error)) {
    return {
      title: 'Processing error',
      description: error.message,
    };
  }

  return { title: error.message };
}

export const promisedWait = (ms) =>
  new Promise((resolve) => {
    setTimeout(() => resolve(), ms);
  });

/**
 * Parse JSON string, return defaultValue if failed
 * @param {string} jsonString - JSON string
 * @param {any} [defaultValue] - default value
 * @returns {any} - parsed JSON or defaultValue
 */
export const parseJson = (jsonString, defaultValue = undefined) => {
  if (!jsonString) {
    return defaultValue;
  }

  try {
    return JSON.parse(jsonString);
  } catch {
    return defaultValue;
  }
};

/**
 * Stringify passed value if it is present, otherwise return undefined
 * @param {any} value - value to stringify
 * @returns {string|null} - stringified value or null
 */
export const stringifyIfPresent = (value) => {
  if (value == null || typeof value === 'string') {
    return value;
  }

  return JSON.stringify(value);
};
